<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between mb-4">
          <p class="text-2xl mb-0">
            Automações de Serviço
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="4"
              >
                <v-text-field
                  v-model="filterName"
                  :append-icon="icons.mdiMagnify"
                  label="Nome"
                  hide-details
                  outlined
                  dense
                  @click:append="applyFilter"
                  @keypress.enter="applyFilter"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              @click="applyFilter"
            >
              Pesquisar
              <v-icon
                right
                dark
              >
                {{ icons.mdiMagnify }}
              </v-icon>
            </v-btn>
            <v-btn
              color="error"
              outlined
              @click="clearFilter"
            >
              Limpar filtro
            </v-btn>

            <v-spacer />

            <v-btn
              color="primary"
              class="pl-4"
              outlined
              @click="openFormToCreate"
            >
              Adicionar nova automação
              <v-icon
                right
                dark
              >
                {{ icons.mdiTablePlus }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredAutomations"
          :items-per-page="10"
          item-key="id"
          disable-sort
          dense
        >
          <!-- eslint-disable vue/valid-v-for -->
          <template
            v-for="col in headersWithFilter"
            v-slot:[`header.${col}`]="{ header }"
          >
            {{ header.text }}

            <v-btn
              color="white"
              icon
              @click="dialogFilter = true"
            >
              <v-icon small>
                {{ icons.mdiFilterMenu }}
              </v-icon>
            </v-btn>
          </template>
          <!-- eslint-disable vue/valid-v-for -->

          <template #[`item.action`]="{ item }">
            <v-btn
              color="info"
              title="Editar"
              icon
              @click="openFormToEdit(item)"
            >
              <v-icon>{{ icons.mdiFileEdit }}</v-icon>
            </v-btn>
            <v-btn
              color="error"
              title="Excluir"
              icon
              @click="confirmDelete(item)"
            >
              <v-icon>{{ icons.mdiDelete }}</v-icon>
            </v-btn>
          </template>

          <template #[`item.name`]="{ item }">
            <div
              class="text-truncate"
              style="max-width: 200px;"
            >
              {{ item.name }}
            </div>
          </template>

          <template #[`item.status`]="{ item }">
            <v-chip
              :color="resolveStatus(item.status).color"
              small
              label
            >
              <span class="white--text">
                {{ resolveStatus(item.status).label }}
              </span>
            </v-chip>
          </template>

          <template #[`item.listName`]="{ item }">
            <span>{{ item.listName || '-' }}</span>
          </template>

          <template #[`item.createdAt`]="{ item }">
            <div class="d-flex flex-column my-1">
              <span>
                <v-icon size="18">
                  {{ icons.mdiCalendar }}
                </v-icon>
                {{ $day(item.createdAt).format('DD/MM/YYYY') }}
              </span>
              <span>
                <v-icon size="18">
                  {{ icons.mdiClock }}
                </v-icon>
                {{ $day(item.createdAt).format('HH:mm') }}
              </span>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <filter-service-automations
      :status="dialogFilter"
      @filter="onAdvancedFilter"
      @close="dialogFilter = false"
    />

    <v-dialog
      v-model="dialogCreateAutomation"
      max-width="1000"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ isEditMode ? 'Editar automação' : 'Nova automação' }}
          <v-spacer />
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-text-field
                v-model="createAutomationForm.name"
                label="Nome"
                hide-details
                outlined
                dense
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-select
                v-model="createAutomationForm.listId"
                :items="listItems"
                label="Lista"
                item-text="label"
                item-value="value"
                hide-details
                outlined
                dense
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-switch
                v-model="createAutomationForm.isActive"
                inset
                hide-details
                label="Ativar?"
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-select
                v-model="createAutomationForm.sendMode"
                :items="sendModeItems"
                label="Modo de envio"
                item-text="label"
                item-value="value"
                hide-details
                outlined
                dense
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="createAutomationForm.description"
                label="Descrição"
                hide-details
                outlined
                auto-grow
              />
            </v-col>
          </v-row>

          <!-- Sequência de ações - apenas no modo edição -->
          <v-row v-if="isEditMode">
            <v-col cols="12">
              <div class="d-flex align-center justify-space-between mb-3">
                <span class="text-subtitle-1 font-weight-medium">
                  SEQUÊNCIA
                </span>

                <v-btn
                  color="primary"
                  small
                  @click="openActionForm"
                >
                  Adicionar ação
                  <v-icon
                    right
                    small
                  >
                    {{ icons.mdiPlus }}
                  </v-icon>
                </v-btn>
              </div>

              <v-card
                v-for="item in sequences"
                :key="item.id"
                class="mb-3"
                outlined
              >
                <v-card-text class="d-flex flex-column flex-md-row align-start align-md-center">
                  <div class="mr-4 mb-2 mb-md-0 d-flex align-center">
                    <v-switch
                      v-model="item.enabled"
                      inset
                      hide-details
                      class="mr-2"
                      @change="toggleActionEnabled(item)"
                    />
                  </div>

                  <div class="mr-4 mb-2 mb-md-0">
                    <v-chip
                      small
                      color="info"
                      text-color="white"
                      class="mb-1"
                    >
                      {{ item.typeLabel }}
                    </v-chip>
                    <div class="text-caption text--secondary">
                      {{ item.delayLabel }}
                    </div>
                  </div>

                  <div class="flex-grow-1 mb-2 mb-md-0">
                    <div class="text-body-2">
                      {{ item.message }}
                    </div>
                  </div>

                  <div class="d-flex align-center">
                    <v-btn
                      icon
                      color="info"
                      class="mr-1"
                      @click="openActionForm(item)"
                    >
                      <v-icon small>
                        {{ icons.mdiFileEdit }}
                      </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="error"
                      @click="confirmDeleteAction(item)"
                    >
                      <v-icon small>
                        {{ icons.mdiDelete }}
                      </v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            outlined
            @click="closeCreateAutomationDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            :disabled="!createAutomationForm.name"
            @click="submitCreateAutomation"
          >
            {{ isEditMode ? 'Atualizar' : 'Salvar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de ação da automação (campos baseados na tela de SMS) -->
    <v-dialog
      v-model="dialogAction"
      max-width="900"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Configurar ação de SMS
          <v-spacer />
          <v-btn
            text
            x-small
            fab
            @click="dialogAction = false"
          >
            <v-icon color="error">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-text-field
                v-model="actionForm.name"
                label="Nome da Campanha"
                hide-details
                outlined
                dense
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-select
                v-model="actionForm.typeSms"
                :items="filteredTypes"
                outlined
                item-text="text"
                item-value="value"
                dense
                label="Tipo"
                hide-details
                @change="filterActionTemplates"
              >
                <template v-slot:item="{ item }">
                  <v-tooltip
                    right
                    open-on-hover
                    nudge-right="50"
                    max-width="320"
                    class="me-5"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        style="display: flex; justify-content: flex-end"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ icons.mdiInformationOutline }}
                      </v-icon>
                    </template>
                    <span>{{ item.description }}</span>
                  </v-tooltip>
                  <span class="mr-5">&nbsp; {{ item.text }}</span>
                </template>
              </v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-select
                v-model="actionForm.smsTemplateId"
                :items="actionTemplates"
                outlined
                dense
                item-text="name"
                item-value="id"
                label="Template"
                hide-details
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-row>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    v-model.number="actionForm.delayAmount"
                    type="number"
                    min="0"
                    label="Disparar após"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-select
                    v-model="actionForm.delayUnit"
                    :items="[
                      { text: 'Minuto(s)', value: 'minutes' },
                      { text: 'Hora(s)', value: 'hours' },
                    ]"
                    item-text="text"
                    item-value="value"
                    label="Unidade"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            outlined
            @click="dialogAction = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            :disabled="!actionForm.name || !actionForm.smsTemplateId || !actionForm.delayAmount"
            @click="submitAction"
          >
            {{ editingActionId ? 'Atualizar ação' : 'Salvar ação' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { mapState, mapActions } from 'vuex'
import {
  mdiCalendar,
  mdiClock,
  mdiFilterMenu,
  mdiFileEdit,
  mdiClose,
  mdiMagnify,
  mdiTablePlus,
  mdiDelete,
  mdiPlus,
  mdiInformationOutline,
} from '@mdi/js'
import {
  smsTypes,
  smsTemplate as smsTemplateEnum,
} from '@/utils/enum'

export default {
  name: 'ServiceAutomations',

  components: {
    FilterServiceAutomations: () => import('./filter.vue'),
  },

  setup() {
    const dialogFilter = ref(false)
    const filterName = ref(null)
    const dialogCreateAutomation = ref(false)
    const isEditMode = ref(false)
    const editingAutomationId = ref(null)
    const advancedFilter = ref({})
    const dialogAction = ref(false)
    const editingActionId = ref(null)

    const createAutomationForm = ref({
      name: null,
      listId: null,
      isActive: true,
      sendMode: 'new',
      trigger: null,
      description: null,
    })

    const sequences = ref([
      {
        id: 1,
        enabled: true,
        typeLabel: 'Mensagem de SMS',
        delayLabel: 'Após 30 minuto(s)',
        message: 'BEM-VINDO {first_name}! Use o cupom BRAVA50: Deposite R$50 e jogue com R$100 agora mesmo. Triplique sua banca aqui: {meu_link}',
      },
      {
        id: 2,
        enabled: true,
        typeLabel: 'Mensagem de SMS',
        delayLabel: 'Após 70 minuto(s)',
        message: '{first_name}, seu cupom BRAVA50 ainda está válido. Não perca a chance de transformar 50 em 100. Ative seu bônus dobrado: {meu_link}',
      },
      {
        id: 3,
        enabled: true,
        typeLabel: 'Mensagem de SMS',
        delayLabel: 'Após 2 hora(s)',
        message: 'Seu Giro Grátis na Roleta está travado. Entre no Grupo VIP agora para desbloquear o link e tentar a sorte sem gastar nada: {meu_link}',
      },
    ])

    const actionForm = ref({
      name: null,
      typeSms: null,
      smsTemplateId: null,
      delayAmount: null,
      delayUnit: 'minutes',
    })

    const allTemplates = ref([])
    const actionTemplates = ref([])

    const headers = [
      { text: 'Ações', value: 'action', align: 'center' },
      { text: 'ID', value: 'id', align: 'center' },
      { text: 'Nome', value: 'name' },
      { text: 'Status', value: 'status' },
      { text: 'Lista', value: 'listName' },
      { text: 'Data de Criação', value: 'createdAt' },
    ]

    const headersWithFilter = [
      'id',
      'name',
      'status',
      'listName',
      'createdAt',
    ]

    const statusItems = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ]

    const sendModeItems = [
      { label: 'Enviar apenas para novos leads', value: 'new' },
      { label: 'Enviar para leads atuais e novos leads', value: 'all' },
    ]

    const resolveStatus = status => {
      const statusMap = {
        1: { label: 'Ativo', color: 'success' },
        0: { label: 'Inativo', color: 'error' },
      }

      return statusMap[status] || { label: 'Não definido', color: 'grey' }
    }

    return {
      dialogFilter,
      filterName,
      dialogCreateAutomation,
      isEditMode,
      editingAutomationId,
      createAutomationForm,
      sequences,
      dialogAction,
      editingActionId,
      actionForm,
      allTemplates,
      actionTemplates,
      headers,
      headersWithFilter,
      statusItems,
      sendModeItems,
      resolveStatus,
      advancedFilter,

      icons: {
        mdiCalendar,
        mdiClock,
        mdiFilterMenu,
        mdiFileEdit,
        mdiClose,
        mdiMagnify,
        mdiTablePlus,
        mdiDelete,
        mdiInformationOutline,
        mdiPlus,
      },
      types: smsTypes,
    }
  },

  computed: {
    ...mapState('serviceListAutomation', {
      lists: 'rows',
    }),
    ...mapState('serviceAutomations', {
      automations: 'rows',
    }),

    filteredTypes() {
      const userId = localStorage.getItem('id')

      if (process.env.VUE_APP_EMPRESA_ID == 1 && (userId === 941 || userId === '941')) {
        return this.types.filter(type => type.serviceId === 6 || type.serviceId === 7)
      }

      if (process.env.VUE_APP_EMPRESA_ID == 1 && (userId === '937' || userId === 937 || userId === '938' || userId === 938 || userId === '939' || userId === 939 || userId === '942' || userId === 942 || userId === '940' || userId === 940)) {
        return this.types.filter(type => type.serviceId === 30)
      }

      if (process.env.VUE_APP_EMPRESA_ID == 1 && (userId === '936' || userId === 936)) {
        return this.types.filter(type => type.serviceId == 6 || type.serviceId == 7)
      }

      if (process.env.VUE_APP_EMPRESA_ID == 1 && (userId === '943' || userId === 943)) {
        return this.types.filter(type => type.serviceId === 8)
      }

      if (process.env.VUE_APP_EMPRESA_ID == 1 && (userId === '877' || userId === 877)) {
        return this.types.filter(type => type.serviceId !== 31 && type.serviceId !== 32)
      }

      return this.types.filter(type =>
        type.serviceId !== 30 &&
        type.serviceId !== 31 &&
        type.serviceId !== 32 &&
        type.serviceId !== 34,
      )
    },

    filteredAutomations() {
      const items = this.automations || []

      return items.filter(item => {
        const byName = this.filterName
          ? String(item.name).toLowerCase().includes(String(this.filterName).toLowerCase())
          : true

        const byAdvancedName = this.advancedFilter?.name
          ? String(item.name).toLowerCase().includes(String(this.advancedFilter.name).toLowerCase())
          : true

        const byId = this.advancedFilter?.id
          ? String(item.id) === String(this.advancedFilter.id)
          : true

        const byStatus = this.advancedFilter &&
          this.advancedFilter.status !== null &&
          this.advancedFilter.status !== undefined
          ? Number(item.status) === Number(this.advancedFilter.status)
          : true

        return byName && byAdvancedName && byId && byStatus
      })
    },

    listItems() {
      return (this.lists || []).map(list => ({
        label: list.name,
        value: list.id,
      }))
    },
  },

  async created() {
    await Promise.all([
      this.fetchListOptions(),
      this.fetchAutomations(),
      this.fetchSmsTemplates(),
    ])
  },

  methods: {
    ...mapActions('serviceListAutomation', ['find']),
    ...mapActions('serviceAutomations', {
      findAutomations: 'find',
      createAutomation: 'create',
      updateAutomation: 'update',
      removeAutomation: 'remove',
    }),
    ...mapActions('serviceAutomationActions', {
      findActions: 'find',
      createAction: 'create',
      updateAction: 'update',
      removeAction: 'remove',
    }),
    ...mapActions('smsTemplates', {
      getTemplates: 'find',
    }),

    async fetchListOptions() {
      try {
        await this.find({ status: 1 })
      } catch (e) {
        // silenciosamente mantém lista vazia em caso de erro
      }
    },

    async fetchSmsTemplates() {
      try {
        const templates = await this.getTemplates({
          status: smsTemplateEnum.Approved,
          isRcs: 0,
        })

        this.allTemplates = templates || []
        this.filterActionTemplates()
      } catch (err) {
        console.error('Erro ao carregar templates de SMS:', err)
        this.allTemplates = []
        this.actionTemplates = []
      }
    },

    async fetchAutomations(params = {}) {
      const filter = {
        name: this.filterName || null,
        ...params,
      }

      await this.findAutomations(filter)
    },

    applyFilter() {
      this.fetchAutomations()
    },

    clearFilter() {
      this.filterName = null
      this.advancedFilter = {}
      this.fetchAutomations()
    },

    onAdvancedFilter(filter) {
      this.advancedFilter = filter || {}
      this.dialogFilter = false
      const params = {}

      if (this.advancedFilter.name) params.name = this.advancedFilter.name
      if (this.advancedFilter.id) params.id = this.advancedFilter.id
      if (this.advancedFilter.status !== null && this.advancedFilter.status !== undefined) {
        params.isActive = Number(this.advancedFilter.status) === 1
      }

      this.fetchAutomations(params)
    },

    openFormToCreate() {
      this.isEditMode = false
      this.editingAutomationId = null
      this.createAutomationForm = {
        name: null,
        listId: null,
        isActive: true,
        sendMode: 'new',
        trigger: null,
        description: null,
      }
      this.dialogCreateAutomation = true
    },

    openActionForm(item = null) {
      const userId = localStorage.getItem('id')
      const initialType = (process.env.VUE_APP_EMPRESA_ID == 1 && (userId === '943' || userId === 943))
        ? smsTypes.find(type => type.serviceId === 8)?.value || smsTypes[0].value
        : smsTypes[0].value

      if (item && item.id) {
        this.editingActionId = item.id
        this.actionForm = {
          name: item.name || null,
          typeSms: item.typeSms ?? initialType,
          smsTemplateId: item.smsTemplateId ?? null,
          delayAmount: item.delayAmount ?? null,
          delayUnit: item.delayUnit || 'minutes',
        }
      } else {
        this.editingActionId = null
        this.actionForm = {
          name: null,
          typeSms: initialType,
          smsTemplateId: null,
          delayAmount: null,
          delayUnit: 'minutes',
        }
      }
      this.filterActionTemplates()
      this.dialogAction = true
    },

    closeCreateAutomationDialog() {
      this.dialogCreateAutomation = false
      this.isEditMode = false
      this.editingAutomationId = null
      this.createAutomationForm = {
        name: null,
        listId: null,
        isActive: true,
        sendMode: 'new',
        trigger: null,
        description: null,
      }
    },

    async submitCreateAutomation() {
      if (!this.createAutomationForm.name) return

      const body = {
        name: this.createAutomationForm.name,
        listId: this.createAutomationForm.listId,
        sendMode: this.createAutomationForm.sendMode,
        isActive: !!this.createAutomationForm.isActive,
        trigger: this.createAutomationForm.trigger || null,
        description: this.createAutomationForm.description || null,
      }

      try {
        if (this.isEditMode && this.editingAutomationId !== null) {
          const status = await this.updateAutomation({ id: this.editingAutomationId, body })

          if (typeof status === 'number' && status >= 200 && status < 300) {
            this.$notify?.('Automação atualizada com sucesso', 'success')
          }
        } else {
          const status = await this.createAutomation(body)

          if (typeof status === 'number' && status >= 200 && status < 300) {
            this.$notify?.('Automação criada com sucesso', 'success')
          }
        }

        await this.fetchAutomations()
        this.closeCreateAutomationDialog()
      } catch (err) {
        this.$notify?.(
          this.isEditMode ? 'Erro ao atualizar automação' : 'Erro ao criar automação',
          'error',
        )
      }
    },

    openFormToEdit(item) {
      this.isEditMode = true
      this.editingAutomationId = item.id
      this.createAutomationForm = {
        name: item.name || null,
        listId: item.listId || null,
        isActive: (item.status ?? 1) === 1,
        sendMode: item.sendMode || 'new',
        trigger: item.trigger || null,
        description: item.description || null,
      }
      this.dialogCreateAutomation = true
      this.loadActions(item.id)
    },

    confirmDelete(item) {
      if (confirm(`Deseja realmente excluir a automação "${item.name}"?`)) {
        this.deleteAutomation(item)
      }
    },

    async deleteAutomation(item) {
      try {
        const status = await this.removeAutomation(item.id)

        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.('Automação excluída com sucesso', 'success')
          await this.fetchAutomations()
        }
      } catch (err) {
        this.$notify?.('Erro ao excluir automação', 'error')
      }
    },

    filterActionTemplates() {
      const smsType = smsTypes.find(t => t.value === this.actionForm.typeSms)

      if (!smsType) {
        this.actionTemplates = []
        return
      }

      this.actionTemplates = (this.allTemplates || []).filter(t =>
        Array.isArray(t.serviceIds) && t.serviceIds.includes(smsType.serviceId),
      )
    },

    async loadActions(automationId) {
      try {
        const actions = await this.findActions({
          automationId,
          params: { isActive: true },
        })

        this.sequences = (actions || []).map(action => ({
          id: action.id,
          enabled: !!action.isActive,
          name: action.name,
          typeSms: action.typeSms,
          smsTemplateId: action.smsTemplateId,
          delayAmount: action.delayAmount,
          delayUnit: action.delayUnit,
          typeLabel: 'Mensagem de SMS',
          delayLabel: action.delayUnit === 'hours'
            ? `Após ${action.delayAmount} hora(s)`
            : `Após ${action.delayAmount} minuto(s)`,
          message: `Template #${action.smsTemplateId}`,
        }))
      } catch (err) {
        console.error('Erro ao carregar ações da automação:', err)
        this.sequences = []
      }
    },

    async toggleActionEnabled(item) {
      if (!item?.id) return

      try {
        const status = await this.updateAction({
          id: item.id,
          body: { isActive: !!item.enabled },
        })

        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.('Ação atualizada com sucesso', 'success')
        } else {
          this.$notify?.('Erro ao atualizar ação', 'error')
        }
      } catch (err) {
        this.$notify?.('Erro ao atualizar ação', 'error')
      } finally {
        if (this.editingAutomationId) {
          await this.loadActions(this.editingAutomationId)
        }
      }
    },

    confirmDeleteAction(item) {
      if (!item?.id) return
      if (confirm('Deseja realmente excluir esta ação?')) {
        this.deleteAction(item)
      }
    },

    async deleteAction(item) {
      try {
        const status = await this.removeAction(item.id)
        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.('Ação excluída com sucesso', 'success')
          if (this.editingAutomationId) {
            await this.loadActions(this.editingAutomationId)
          }
        } else {
          this.$notify?.('Erro ao excluir ação', 'error')
        }
      } catch (err) {
        this.$notify?.('Erro ao excluir ação', 'error')
      }
    },

    async submitAction() {
      if (!this.editingAutomationId) {
        this.$notify?.('Automação não selecionada para vincular a ação.', 'error')
        return
      }

      if (!this.actionForm.name || !this.actionForm.smsTemplateId || !this.actionForm.delayAmount) {
        return
      }

      const body = {
        name: this.actionForm.name,
        typeSms: this.actionForm.typeSms,
        smsTemplateId: this.actionForm.smsTemplateId,
        delayAmount: Number(this.actionForm.delayAmount),
        delayUnit: this.actionForm.delayUnit,
        isActive: true,
      }

      try {
        const status = this.editingActionId
          ? await this.updateAction({ id: this.editingActionId, body })
          : await this.createAction({ automationId: this.editingAutomationId, body })

        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.(
            this.editingActionId ? 'Ação atualizada com sucesso' : 'Ação criada com sucesso',
            'success',
          )
          await this.loadActions(this.editingAutomationId)
          this.dialogAction = false
          this.editingActionId = null
        }
      } catch (err) {
        console.error('Erro ao salvar ação da automação:', err)
        this.$notify?.('Erro ao salvar ação da automação', 'error')
      }
    },
  },
}
</script>

